import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 63,
	viewBox: "0 0 72 63",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.8663 25.2527C41.4159 25.2527 42.6721 26.509 42.6721 28.0586V45.9979L42.6708 46.0347C42.6707 46.0395 42.6706 46.0477 42.6706 46.0593C42.6705 46.0943 42.671 46.159 42.6743 46.2491C42.681 46.4302 42.699 46.7077 42.7452 47.0481C42.8396 47.7429 43.0411 48.6216 43.4465 49.4637C43.8448 50.2907 44.4173 51.0401 45.2566 51.5928C46.0844 52.1379 47.35 52.6099 49.3361 52.6099C50.8857 52.6099 52.1419 53.8662 52.1419 55.4158C52.1419 56.9654 50.8857 58.2217 49.3361 58.2217C46.4118 58.2217 44.0386 57.5099 42.1702 56.2795C40.3132 55.0566 39.132 53.4385 38.3904 51.8981C37.6559 50.3728 37.3313 48.884 37.1846 47.8032C37.1102 47.2558 37.0789 46.7934 37.0664 46.4568C37.0602 46.2879 37.0586 46.1491 37.0589 46.0454C37.059 45.9935 37.0596 45.9502 37.0603 45.9162L37.0604 45.9109V28.0586C37.0604 26.509 38.3166 25.2527 39.8663 25.2527Z",
			fill: "url(#paint0_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M31.0963 19.2903C29.5467 19.2903 28.2905 20.5466 28.2905 22.0962V50.5575L28.2918 50.5943C28.2919 50.5991 28.292 50.6073 28.292 50.6189C28.2921 50.6539 28.2916 50.7186 28.2883 50.8086C28.2816 50.9898 28.2636 51.2673 28.2174 51.6077C28.123 52.3025 27.9215 53.1812 27.516 54.0233C27.1178 54.8503 26.5453 55.5997 25.706 56.1524C24.8782 56.6975 23.6126 57.1695 21.6265 57.1695C20.0769 57.1695 18.8207 58.4258 18.8207 59.9754C18.8207 61.525 20.0769 62.7813 21.6265 62.7813C24.5508 62.7813 26.924 62.0695 28.7924 60.8391C30.6494 59.6162 31.8306 57.9981 32.5722 56.4577C33.3067 54.9324 33.6313 53.4436 33.778 52.3628C33.8524 51.8154 33.8837 51.353 33.8962 51.0164C33.9024 50.8475 33.904 50.7087 33.9037 50.605C33.9036 50.5531 33.903 50.5098 33.9023 50.4758L33.9022 50.4705V22.0962C33.9022 20.5466 32.646 19.2903 31.0963 19.2903Z",
			fill: "url(#paint1_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3055 -4.19617e-05C40.9227 0.000228531 45.4764 4.71145 45.4764 10.5224V16.8349H45.451C45.3328 18.6925 44.7496 20.4173 43.8192 21.8877H43.8866C43.855 21.8952 43.8209 21.9141 43.784 21.9423C43.631 22.1809 43.4675 22.4113 43.2967 22.6357C43.0007 23.2081 42.6909 24.0497 42.4959 24.9521C42.6083 25.5004 42.6707 26.0706 42.6707 26.6562C42.6705 30.3937 40.2536 33.5089 37.0457 34.2187C37.0533 34.1495 37.0584 34.0792 37.0584 34.0078C37.0584 33.0466 36.352 32.2675 35.4803 32.2675C34.6086 32.2675 33.9022 33.0466 33.9022 34.0078C33.9022 34.0488 33.9045 34.0895 33.9071 34.1298C30.8789 33.275 28.6405 30.2526 28.6405 26.6552H28.3114C28.3113 25.1974 27.7905 23.5625 27.3104 22.6347C27.14 22.4109 26.9777 22.1803 26.825 21.9423C26.7882 21.9141 26.754 21.8951 26.7225 21.8877H26.7909C25.8604 20.4173 25.2772 18.6925 25.159 16.8349H25.1336V10.5224C25.1336 4.71128 29.6881 -4.19617e-05 35.3055 -4.19617e-05Z",
			fill: "#6D3B78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.281 28.0587C50.8306 28.0587 52.0868 29.3149 52.0868 30.8645V39.6329C52.0868 41.1825 50.8306 42.4387 49.281 42.4387C47.7313 42.4387 46.4751 41.1825 46.4751 39.6329V30.8645C46.4751 29.3149 47.7313 28.0587 49.281 28.0587Z",
			fill: "url(#paint2_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M58.6854 17.5366C60.235 17.5366 61.4912 18.7928 61.4912 20.3424V41.0357C61.4912 42.5853 60.235 43.8416 58.6854 43.8416C57.1357 43.8416 55.8795 42.5853 55.8795 41.0357V20.3424C55.8795 18.7928 57.1357 17.5366 58.6854 17.5366Z",
			fill: "url(#paint3_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.2324 22.4468C69.782 22.4468 71.0382 23.703 71.0382 25.2527L71.0382 31.5659C71.0382 33.1155 69.782 34.3717 68.2324 34.3717C66.6827 34.3717 65.4265 33.1155 65.4265 31.5659L65.4265 25.2527C65.4265 23.703 66.6827 22.4468 68.2324 22.4468Z",
			fill: "url(#paint4_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.80587 33.126C4.3555 33.126 5.61173 34.3822 5.61173 35.9319V42.2451C5.61173 43.7947 4.3555 45.0509 2.80587 45.0509C1.25623 45.0509 0 43.7947 0 42.2451V35.9319C0 34.3822 1.25623 33.126 2.80587 33.126Z",
			fill: "url(#paint5_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.2103 21.201C13.7599 21.201 15.0162 22.4573 15.0162 24.0069V44.3494C15.0162 45.8991 13.7599 47.1553 12.2103 47.1553C10.6606 47.1553 9.40442 45.8991 9.40442 44.3494V24.0069C9.40442 22.4573 10.6606 21.201 12.2103 21.201Z",
			fill: "url(#paint6_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.6147 27.5142C23.1644 27.5142 24.4206 28.7704 24.4206 30.32V41.1928C24.4206 42.7424 23.1644 43.9986 21.6147 43.9986C20.0651 43.9986 18.8089 42.7424 18.8089 41.1928V30.32C18.8089 28.7704 20.0651 27.5142 21.6147 27.5142Z",
			fill: "url(#paint7_linear_23_477)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 41.5008,
			cy: 23.5412,
			rx: 3.74056,
			ry: 3.90015,
			fill: "#6D3B78"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 41.5008,
			cy: 23.5411,
			rx: 2.24434,
			ry: 2.34009,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.5759,
			cy: 23.5412,
			rx: 3.74056,
			ry: 3.90015,
			fill: "#6D3B78"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.5759,
			cy: 23.5411,
			rx: 2.24434,
			ry: 2.34009,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 29.6935,
			cy: 24.9019,
			r: 1.0522,
			fill: "#6D3B78"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41.6184,
			cy: 24.9019,
			r: 1.0522,
			fill: "#6D3B78"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_23_477",
				x1: 44.6004,
				y1: 25.2527,
				x2: 44.6004,
				y2: 58.2217,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_23_477",
				x1: 26.3622,
				y1: 19.2903,
				x2: 26.3622,
				y2: 62.7813,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_23_477",
				x1: 49.281,
				y1: 28.0587,
				x2: 49.281,
				y2: 42.4387,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_23_477",
				x1: 58.6854,
				y1: 17.5366,
				x2: 58.6854,
				y2: 43.8416,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_23_477",
				x1: 68.2324,
				y1: 22.4468,
				x2: 68.2324,
				y2: 34.3717,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_23_477",
				x1: 2.80587,
				y1: 33.126,
				x2: 2.80587,
				y2: 45.0509,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_23_477",
				x1: 12.2103,
				y1: 21.201,
				x2: 12.2103,
				y2: 47.1553,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_23_477",
				x1: 21.6147,
				y1: 27.5142,
				x2: 21.6147,
				y2: 43.9986,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .296875,
					stopColor: "#6D3B78"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B062C2"
				})]
			})
		] })
	]
});
export default SvgLogo;
